import React, { useState } from 'react';
import './SendEmail.scss';
import Recovery from './Recovery'; 
import ErrorComponent from './Error'; 
import { sendResetPasswordEmail } from './../../../../crud/users_api/users';

interface SendEmailProps {
  onBack: () => void;
}

const SendEmail: React.FC<SendEmailProps> = ({ onBack }) => {
  const [email, setEmail] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    sendResetPasswordEmail(email)
      .then(() => {
        setIsLoading(false);
        setShowSuccess(true);
      })
      .catch((error) => {
        setIsLoading(false);
        setShowError(true);
        console.log(error);
      });
  };

  if (isLoading) {
    return (
      <div className="lp-sub__loading">
        <div className="lp-sub__spinner" />
        <span className="lp-sub__loading-text">Enviando correo...</span>
      </div>
    );
  }

  if (showSuccess) return <Recovery onBack={onBack} />;
  if (showError) return <ErrorComponent onBack={onBack} />;

  return (
    <form onSubmit={handleSubmit} className="lp-sub">
      <h3 className="lp-sub__title">Recuperar contraseña</h3>
      <p className="lp-sub__desc">Ingresa tu correo y te enviaremos instrucciones para restablecerla.</p>

      <div className="lp-sub__field">
        <label htmlFor="recovery-email" className="lp__label">Correo electrónico</label>
        <input
          type="email"
          id="recovery-email"
          className="lp__input"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="tu@correo.com"
          required
        />
      </div>

      <button type="submit" className="lp__submit">
        Enviar enlace
      </button>

      <button type="button" className="lp-sub__back" onClick={onBack}>
        ← Volver al inicio de sesión
      </button>
    </form>
  );
};

export default SendEmail;
